/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppleDeviceRegistrationDto
 */
export interface AppleDeviceRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof AppleDeviceRegistrationDto
     */
    pushToken?: string | null;
}

export function AppleDeviceRegistrationDtoFromJSON(json: any): AppleDeviceRegistrationDto {
    return AppleDeviceRegistrationDtoFromJSONTyped(json, false);
}

export function AppleDeviceRegistrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppleDeviceRegistrationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pushToken': !exists(json, 'pushToken') ? undefined : json['pushToken'],
    };
}

export function AppleDeviceRegistrationDtoToJSON(value?: AppleDeviceRegistrationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pushToken': value.pushToken,
    };
}

